import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA006_Request,
  IAPI_STA006_Response,
} from "../../../type/apiType";

// 日々更新法人職員育休更新
const httpAPI_STA006 = async (
  param: IAPI_STA006_Request
): Promise<IAPI_STA006_Response> => {
  let res = await http.post(ApiUrl.API_STA006, {
    ...param,
  });

  return res.data;
};

export { httpAPI_STA006 };
